import { resolveAvatarSrc } from "../../avatars/index.js";

const STYLE_ID = "ls-monitor-editor-style";
const HIDE_AFTER_MS = 2500;
const REFRESH_MS = 200;

const editors = new Map(); // monitorId -> { el, username, color, avatar, updatedAt }
let timer = null;

const SAFE_COLOR = /^#[0-9a-f]{3,8}$|^rgba?\([\d\s.,%]+\)$/i;

const STYLE = `
    .ls-monitor-editor {
        position: fixed;
        z-index: 20;
        display: flex;
        align-items: center;
        gap: 5px;
        padding: 2px 9px 2px 2px;
        border-radius: 999px;
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.35);
        transform: translate(-50%, 0);
        pointer-events: none;
        white-space: nowrap;
        font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    }
    .ls-monitor-editor img {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid #fff;
        display: block;
    }
    .ls-monitor-editor span {
        color: #fff;
        font-size: 0.7rem;
        font-weight: 600;
    }
`;

const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement("style");
    style.id = STYLE_ID;
    style.textContent = STYLE;
    document.head.appendChild(style);
};

const findMonitorEl = (monitorId) =>
    document.querySelector(`[data-monitor-id="${CSS.escape(monitorId)}"]`);

const createEl = (entry) => {
    ensureStyles();

    const el = document.createElement("div");
    el.className = "ls-monitor-editor";
    el.style.background = SAFE_COLOR.test(entry.color || "")
        ? entry.color
        : "#855cd6";
    el.innerHTML = `
        <img src="${resolveAvatarSrc(entry.avatar)}" alt="" />
        <span></span>
    `;
    el.querySelector("span").textContent = entry.username || "Alguien";
    document.body.appendChild(el);
    return el;
};

const destroy = (monitorId) => {
    editors.get(monitorId)?.el.remove();
    editors.delete(monitorId);
};

const tick = () => {
    const now = Date.now();

    for (const [monitorId, entry] of editors) {
        if (now - entry.updatedAt > HIDE_AFTER_MS) {
            destroy(monitorId);
            continue;
        }

        const monitorEl = findMonitorEl(monitorId);
        if (!monitorEl) {
            entry.el.style.display = "none";
            continue;
        }

        const rect = monitorEl.getBoundingClientRect();
        entry.el.style.display = "flex";
        entry.el.style.left = `${rect.left + rect.width / 2}px`;
        entry.el.style.top = `${rect.bottom + 4}px`;
    }

    if (editors.size === 0) {
        clearInterval(timer);
        timer = null;
    }
};

export const showMonitorEditor = ({ monitorId, username, color, avatar }) => {
    if (!monitorId) return;

    let entry = editors.get(monitorId);
    if (!entry) {
        entry = { username, color, avatar };
        entry.el = createEl(entry);
        editors.set(monitorId, entry);
    } else if (entry.username !== username) {
        destroy(monitorId);
        entry = { username, color, avatar };
        entry.el = createEl(entry);
        editors.set(monitorId, entry);
    }

    entry.updatedAt = Date.now();

    if (!timer) timer = setInterval(tick, REFRESH_MS);
};

export const clearMonitorEditors = () => {
    for (const monitorId of Array.from(editors.keys())) destroy(monitorId);
    clearInterval(timer);
    timer = null;
};
